import React, { FC } from "react";
import { Badge, Button, Popover} from "react-bootstrap";
import { Tag, creators, PSM, psm, Category, Package } from "./types/Types";


interface IFilterProps {
    tags?: Tag[] | Category[];
    filtersSelect: Array<Tag | PSM | Category | Package>;
    setFiltersSelect: (filterSelect: Array<Tag | PSM | Category | Package>) => void;
    setShowTagManage?: (showTagManage: boolean) => void;
    screenType: "DocMasters" | "Packages" | "PackageEditor";
}

export const DocMastersFilter: FC<IFilterProps> = (props) => {

    function handleFilterSelect(props: IFilterProps, filter: Tag | PSM | Category | Package) {
        // remove filter if it is already selected
        if (props.filtersSelect.some((f) => f === filter)) {
            props.setFiltersSelect(props.filtersSelect.filter((f) => f !== filter));
        // otherwise add filter
        } else if (creators.some((creator) => creator === filter)) {
            props.setFiltersSelect([...props.filtersSelect.filter((f) => !creators.some((creator) => creator === f)), filter]);
        } else if ((props.screenType === "Packages" || props.screenType === "PackageEditor" ) && psm.some((psm) => psm === filter)) {
            props.setFiltersSelect([...props.filtersSelect.filter((f) => !psm.some((psm) => psm === f)), filter]);
        } else {
            props.setFiltersSelect([...props.filtersSelect, filter]);
        }
    }
    
    function handleFilterReset(props: IFilterProps) {
        props.setFiltersSelect([]);
    }

    return (
        <Popover.Body>
            {/* lighten the enabled filters */}
            <h3><i className="fa-solid fa-filter"/>Filters</h3>
            {!(props.screenType === "Packages") && (
                <>
                    {creators.map((creator) => (
                        props.filtersSelect.some((tag) => tag === creator) ? (
                            <Badge className="tag" pill bg="info" key={creator.name} onClick={() => handleFilterSelect(props, creator)}>{creator.name}</Badge>
                        ) : (
                            <Badge className="tag" pill bg="secondary" key={creator.name} onClick={() => handleFilterSelect(props, creator)}>{creator.name}</Badge>
                        )
                    ))}
                    <br/>
                </>
            )}
            {psm.map((psm) => (
                <Badge className="tag" pill bg={props.filtersSelect.some((tag) => tag === psm) ? "info" : "secondary"} key={psm.name} onClick={() => handleFilterSelect(props, psm)}>{psm.name}</Badge>
            ))}
            {props.tags?.length > 0 && (
                <>
                    <h3 style={{marginTop:'20px'}}><i className="fa-solid fa-tags"/>Categories</h3>
                    {props.tags.map((tag) => (
                        props.filtersSelect.some((t) => t === tag) ? (
                            <Badge className="tag" pill bg="info" key={tag.name} onClick={() => handleFilterSelect(props, tag)}>{tag.name}</Badge>
                        ) : (
                            <Badge className="tag" pill bg="secondary" key={tag.name} onClick={() => handleFilterSelect(props, tag)}>{tag.name}</Badge>
                        )
                    ))}
                </>
            )}

            <hr />

            <div className="d-flex justify-content-between">
                <Button variant="link-text" onClick={() => handleFilterReset(props)}>Reset</Button>
                {/* {props.screenType === "DocMasters" && (
                    <Button variant="text" className="btn-text" onClick={() => props.setShowTagManage(true)}>More</Button>
                )} */}
            </div>
        </Popover.Body>
    )
}

/*
export const DocMastersTagManage: FC<IFilterProps> = (props) => {
    const [searchTagText, setSearchTagText] = useState<string>('');
    const [showAddTag, setShowAddTag] = useState<boolean>(false);

    // TODO: replace with real user tags from rwapi
    const userTagsTEST: Tag[] = [
        { name: "TEST Tag 1" },
        { name: "TEST Tag 2" },
        { name: "TEST Tag 3" },
        { name: "TEST Tag 4" }
    ];

    const mapTagsToTable = (tags: Tag[], searchDocText: string) => {
        if (searchDocText > '') {
            tags = tags.filter((tag) => tag.name.toLowerCase().includes(searchDocText.toLowerCase()));
        }

        return tags.reduce((acc, tag, index, array) => {
            if (index % 2 === 0) {
                acc.push(
                    <div key={tag.name}>
                        <Badge bg="system" className="tag" pill>{tag.name}</Badge>
                        <br/>
                        <Badge bg="system" className="tag" pill>{array[index + 1] ? array[index + 1].name : ""}</Badge>
                    </div>
                );
            }
            return acc;
        }, []);
    }

    return (
        <Modal show={true} onHide={() => props.setShowTagManage(false)} size="xl" centered>
            <InputGroup className="search-bar">
                <InputGroup.Text>
                    <i className="fa-duotone fa-magnifying-glass fa-indicator"/>
                </InputGroup.Text>
                <Form.Control
                    type="text" 
                    placeholder="Type to search for a tag..." 
                    onChange={(e) => setSearchTagText(e.target.value)} 
                    value={searchTagText}
                />

                <div className="buttons-container">
                    {searchTagText > '' && (
                        <OverlayTrigger key="clearSearchButton" placement="bottom" delay={200} overlay={<Tooltip>Clear search</Tooltip>}>
                            <Button variant="link" id="clearSearchBtn" onClick={() => {
                                if (searchTagText !== '')
                                    setSearchTagText('');
                            }}>
                                <i id="clearSearchBtn2" className="fa-regular fa-xmark"/>
                            </Button>
                        </OverlayTrigger>
                    )}

                    <OverlayTrigger key="addNewTagButton" placement="bottom" delay={200} overlay={<Tooltip>Add new tag</Tooltip>}>
                        <Button variant="primary" onClick={() => {setShowAddTag(true)}}><i className="fa-regular fa-plus"/>Tag</Button>
                    </OverlayTrigger>
                </div>
            </InputGroup>

            <Modal.Body>
                <Container>
                    <Row>
                        <Col xs="4">
                            <h3><i className="fa-regular fa-circle-info"/>&nbsp;<b>System Tags</b></h3>
                            {mapTagsToTable(props.tags, searchTagText)}
                        </Col>
                        <Col>
                            <h3><i className="fa-regular fa-tags"/>&nbsp;<b>User Tags</b></h3>
                            {mapTagsToTable(userTagsTEST, searchTagText)}
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <Button variant="text" onClick={() => {setSearchTagText('');props.setShowTagManage(false)}}>Cancel</Button>
                <Button variant="primary" onClick={() => {setSearchTagText('');props.setShowTagManage(false)}}>Save</Button>
            </Modal.Footer>
        </Modal>
    )
}
*/